import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useEffect } from "react";
import { highlightPointsState } from "../../../store/HighlightPointsState";
import { elapsedTimeState } from "../../../store/ElapsedTimeState";
import { routePointEditingState } from "../../../store/RoutePointEditingState";
import { useATCPlan } from "../../../store/ATCPlanState";
import { useAlert } from "../../../hooks/useAlert";
import { getCycleDate } from "../../../Authorization";
import axios from "axios";


function FlightPlanDispatcher({contents}) {
  const {atcPlan, changeATCPlanEdit} = useATCPlan();
  const [highlightPoints, setHighlightPoints] = useRecoilState(highlightPointsState);
  const elapsedTime = useRecoilValue(elapsedTimeState);
  const setRoutePointEditing = useSetRecoilState(routePointEditingState);
  const {showError} = useAlert();

  useEffect(()=> {
    contents.parsePlan(atcPlan.edit.json);
  }, [contents, atcPlan.edit.json]);

  useEffect(() => {
    contents.hilightPoints(highlightPoints);
  }, [contents, highlightPoints]);

  useEffect(() => {
    contents.onPlanUpdate((plan) => {
      const params = new URLSearchParams();
      params.append('plan', JSON.stringify(plan));
      params.append('orig', atcPlan.edit.text);
      params.append('cycleDate', getCycleDate());
      params.append('parse', "true");
      axios.post('cgi/format.cgi', params).then(res => {
        changeATCPlanEdit({text: res.data.atc_plan, json: res.data.json});
      }).catch(error => {
        showError('Failed to convert to ATC', {timeout: 5000});
        console.log(`Failed to convert to ATC : ${error.message} \n parameter : ${params.toString()}`)
      });

    });
    contents.onHilightPoints((points) => {
      setHighlightPoints(points);
    });
  }, [contents, setHighlightPoints, changeATCPlanEdit, atcPlan.edit.text, showError]);

  //FlightPlanのediting変数の変更を検知してルート編集中ステートを更新
  useEffect(() => {
    let editing = contents.editing;
    Object.defineProperty(contents, 'editing', {
      get: () => {
        return editing;
      },
      set: newValue => {
        editing = newValue;
        setRoutePointEditing(editing);
      }
    });
  }, [contents, setRoutePointEditing]);

  useEffect(() => {
    contents.setTime(elapsedTime);
  }, [contents, elapsedTime]);

  useEffect(() => {
    contents.onError((msg, err, param) => {
      showError(msg, {timeout: 5000});
      const e = err ? err.message : '';
      const p = param ? JSON.stringify(param) : '';
      console.log(`${msg} : ${e} \n parameter : ${p}`);
    });
  },[contents, showError]);

  //dont draw anything
  return null;
}

export default FlightPlanDispatcher